import { MutationTree } from 'vuex';
import { ReportState } from '.';
import {
  CLEAR_REPORTING_LIST_OPTIONS,
  REMOVE_ALL_REPORT_LABEL_VALUES,
  SET_FLOW_LIST_OPTIONS,
  SET_LABELS,
  SET_REPORTING_DATE_RANGE,
  SET_REPORTING_FLOW,
  SET_REPORT_LOADING,
} from '@/store/reports/mutationTypes';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import { DateOption, ReportLabels } from '@/features/reports/models';

export const mutations: MutationTree<ReportState> = {
  [SET_LABELS](state, request: ReportLabels) {
    state.labels[request.reportId] = request;
    state.labels = set(state.labels);
  },
  [REMOVE_ALL_REPORT_LABEL_VALUES](state) {
    state.labels = {};
    state.labels = set(state.labels);
  },
  [SET_REPORTING_DATE_RANGE](state, option: DateOption) {
    if (state.selectedDateOption && state.selectedDateOption !== option) {
      delete state.labels[state.selectedFlowId];
    }
    state.selectedDateOption = option;
  },
  [SET_REPORTING_FLOW](state, flowId: string) {
    if (state.selectedFlowId && state.selectedFlowId !== flowId) {
      delete state.labels[state.selectedFlowId];
    }

    state.selectedFlowId = flowId;
  },
  [CLEAR_REPORTING_LIST_OPTIONS](state) {
    state.flowListOptions = [];
  },
  [SET_FLOW_LIST_OPTIONS](state, flows: FlowListItemViewModel[]) {
    state.flowListOptions = [
      { id: 'all', name: 'All Flows' },
      ...flows.map((flow) => ({ id: flow.id, name: flow.name })),
    ];
  },
  [SET_REPORT_LOADING](state, loading: boolean) {
    state.isReportLoading = loading;
  },
};

// Vuex doesn't detect changes to items in an array,
// so we have to mutate the array itself to maintain
// reactivity
function set(obj: object) {
  return { ...obj };
}
